import styled from "styled-components";
import Colors from "../../global/color";

const StyledSearchModal = styled.div`
  > div  {
    transition: none;
  }

  .search-modal-wrapper {}

  .search-modal-dialog {
    max-width: none;
    min-height: 100%;
    padding: 0;
  }

  .search-modal-content {
    border: none;
    border-radius: 0;
    min-height: 100vh;

    > div {
      padding: 0;
    }
  }

  .search-modal-container {
    margin: 0 auto;
    padding: 20px 16px;
    ${({isTablet}) => isTablet ? `
    ` : ``
    }
    ${({isMobile, isTablet}) => !isMobile && !isTablet ? `
    max-width: 1320px;
    ` : ``
    }
  }

  .search-modal-header {
    background: ${Colors.blackest};
    position: relative;
  }

  .search-modal-belt {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .search-modal-logo {
  }

  .search-modal-logo-link {
    img {
      display: block;
      height: 32px;
    }
  }

  .search-modal-close {
    background: none;
    border: none;
    cursor: pointer;
    height: 44px;
    padding: 0;
    position: absolute;
    right: 6px;
    top: 6px;
    width: 44px;

    svg {
      height: 20px;
      width: 20px;

      [stroke] {
        stroke: ${Colors.goldDark};
      }
    }
  }

  .search-modal-form {
    display: flex;
    justify-content: center;
  }

  .search-modal-form-item {
    flex-basis: 100%;
    position: relative;
    ${({isTablet, isDesktop}) => isTablet || isDesktop ? `
    flex-basis: auto;
    ` : ``
    }

    svg {
      left: 20px;
      position: absolute;
      top: 50%;
      transform: translate(0,-50%);
    }

    [fill="#999999"] {
      fill: ${Colors.white};
    }
  }

  .st-default-search-input {
    background: none;
    border-radius: 0;
    border: 1px solid ${Colors.goldDark};
    box-sizing: border-box;
    color: ${Colors.white};
    font-family: FuturaPT-Medium;
    font-size: 16px;
    height: 60px;
    padding-left: 56px;
    width: 100%;
    ${({isTablet, isDesktop}) => isTablet || isDesktop ? `
    width: 710px;
    ` : ``
    }

    &::placeholder {
      color: ${Colors.white};
    }

    &:focus {
      border: 1px solid ${Colors.goldDark};
    }
  }

  .search-modal-results {}

  .search-modal-container {}

  .st-search-container {
    margin: 0 auto;
    max-width: 400px;
    ${({isTablet, isDesktop}) => isTablet || isDesktop ? `
    max-width: none;
    ` : ``
    }
  }

  .st-query-present {}

  .st-ui-embed {}

  .st-ui-container {}

  .st-ui-container-primary_content {
    margin-bottom: 20px;
  }

  .st-search-summary {
    display: none;
  }

  .st-search-results {
    .st-ui-result {
      border: 1px solid ${Colors.lightGrey};
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
      padding: 0;
      position: relative;
      ${({isTablet, isDesktop}) => isTablet || isDesktop ? `
      flex-direction: column;
      justify-content: center;
      min-height: 220px;
      ` : ``
      }

      &:hover {
        .st-ui-type-heading {
          text-decoration: underline;
        }

        .st-ui-type-detail {
          color: ${Colors.blackest};
        }
      }

      &:before {
        content: normal;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .st-ui-thumbnail {
        background-repeat: no-repeat;
        background-position: center center;
        flex-basis: 100%;
        height: 225px;
        float: none;
        margin: 0;
        overflow: visible;
        ${({isTablet, isDesktop}) => isTablet || isDesktop ? `
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 300px;
        ` : ``
        }
      }

      .st-ui-type-heading {
        color: ${Colors.blackest};
        flex-basis: 100%;
        font-family: FuturaPT-Medium;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0.25px;
        padding: 20px 16px 0 16px;
        margin-bottom: 10px;
        white-space: normal;
        ${({isTablet, isDesktop}) => isTablet || isDesktop ? `
        font-size: 18px;
        padding-left: 320px;
        ` : ``
        }

        em {
          box-shadow: none;
          background: none !important;
        }
      }

      .st-ui-type-detail {
        color: ${Colors.blackest};
        flex-basis: 100%;
        font-size: 16px;
        font-family: FuturaPT-Book;
        line-height: 22px;
        max-height: none;
        overflow: visible;
        padding: 0 16px 20px 16px;
        ${({isTablet, isDesktop}) => isTablet || isDesktop ? `
        padding-left: 320px;
        ` : ``
        }

        em {
          box-shadow: none;
          background: none !important;
        }
      }

      .st-ui-type-detail-bold {
        display: inline-block;
        color: ${Colors.gold};
        font-family: FuturaPT-Medium;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 3px;
        line-height: 22px;
        margin-bottom: 10px;
        position: relative;
        text-transform: uppercase;
        width: calc(100% - 30px);

        &:after {
          background: #fff;
          content: '';
          height: 22px;
          position: absolute;
          right: -30px;
          top: 0;
          width: 30px;
        }
      }
    }
  }

  .st-ui-container-footer_bar {}

  .st-ui-pagination {
    > div {
      display: flex;
      justify-content: center;
    }

    .st-ui-pagination-link {
      color: ${Colors.blackest};
      font-family: FuturaPT-Book;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      margin-right: 10px;
      text-transform: capitalize;

      &:hover {
        text-decoration: underline;
      }

      &:last-child {
        margin-right: 0;
      }

      .st-ui-arrow {
        border-color: ${Colors.blackest};
      }
    }

    .st-ui-pagination-link.active {
      font-weight: 600;
    }
  }

`;

export {
  StyledSearchModal
};
